import React from 'react'
import { Button } from '@/components/ui/button'
import { Heading4 } from '@/components/ui/typography'
import {
  FormBaseButtonContainer,
  FormBaseContainer,
  FormBaseFieldBlock,
  FormBaseFieldGroup,
  FormBaseFieldLabel,
  FormBaseRow,
} from 'components/Form/Form.styles'
import { Field, Form, FormikProps, withFormik } from 'formik'

import { ClientSubscriptionDetailBackOfficeDto } from '../../../../../api/Trading-Accounts/Types/ClientSubscriptionDetailBackOfficeDto'
import { FormSubmitValues } from '../../../../../utils/formValidation'
import { SubscriptionRequestType } from './SubscriptionRequestType'
import { SubscriptionTimeInForce } from './SubscriptionTimeInForce'

export type ClientSubscriptionStatusChangeFormValues = {
  overrideOpenPositionsForCancel: boolean
  subscriptionRequestTypeId: number
}

export type ClientSubscriptionStatusChangeSubmitValues = {
  clientId: string
  subscriptionTimeInForceId: SubscriptionTimeInForce
  overrideOpenPositionsForCancel: boolean
  subscriptionRequestTypeId: SubscriptionRequestType
  subscriptions: {
    subscriptionDetailId: string
    subscriptionRequestTypeId: SubscriptionRequestType
  }[]
}

const ClientSubscriptionChangeStatusFormUI = ({
  handleSubmit,
  isSubmitting,
  onClose,
}: FormikProps<ClientSubscriptionStatusChangeFormValues> & OuterProps) => {
  const handleSave = (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault()
    handleSubmit()
  }

  return (
    <React.Fragment>
      <Heading4>Price Override</Heading4>
      <FormBaseContainer>
        <Form onSubmit={handleSave}>
          <FormBaseFieldBlock>
            <FormBaseRow>
              <FormBaseFieldLabel>Status</FormBaseFieldLabel>
              <FormBaseFieldGroup>
                <Field component='select' name='subscriptionRequestTypeId'>
                  <option value='' disabled>
                    None
                  </option>
                  {[
                    { id: 1, name: 'Add' },
                    { id: 2, name: 'Cancel' },
                    { id: 3, name: 'Update' },
                  ].map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.name}
                    </option>
                  ))}
                </Field>
              </FormBaseFieldGroup>
            </FormBaseRow>
          </FormBaseFieldBlock>
          <FormBaseFieldBlock>
            <FormBaseRow>
              <FormBaseFieldLabel>Override Open Positions For Cancel</FormBaseFieldLabel>
              <FormBaseFieldGroup>
                <Field name='overrideOpenPositionsForCancel' type='checkbox' />
              </FormBaseFieldGroup>
            </FormBaseRow>
          </FormBaseFieldBlock>
          <FormBaseButtonContainer
            style={{ justifyContent: 'flex-end', marginTop: '2rem', gap: '1rem' }}
          >
            <Button disabled={isSubmitting} key='button' type='button' onClick={onClose}>
              Cancel
            </Button>
            <Button key='button' type='submit' disabled={isSubmitting}>
              Submit
            </Button>
          </FormBaseButtonContainer>
        </Form>
      </FormBaseContainer>
    </React.Fragment>
  )
}

interface OuterProps {
  data: ClientSubscriptionDetailBackOfficeDto
  clientId: string
  id: string
  onSubmit(values: FormSubmitValues<ClientSubscriptionStatusChangeSubmitValues>): Promise<void>
  onClose: () => void
}

const dataToSubmit = (
  values: ClientSubscriptionStatusChangeFormValues,
  clientId: string,
  subscriptionDetailId: string
): FormSubmitValues<ClientSubscriptionStatusChangeSubmitValues> => {
  return {
    clientId,
    subscriptionTimeInForceId: 1,
    overrideOpenPositionsForCancel: values.overrideOpenPositionsForCancel,
    subscriptionRequestTypeId: Number(values.subscriptionRequestTypeId),
    subscriptions: [
      { subscriptionDetailId, subscriptionRequestTypeId: values.subscriptionRequestTypeId },
    ],
  }
}

export const ClientSubscriptionChangeStatusForm = withFormik<
  OuterProps,
  ClientSubscriptionStatusChangeFormValues
>({
  mapPropsToValues: () => {
    return {
      subscriptionRequestTypeId: 1,
      overrideOpenPositionsForCancel: false,
    }
  },
  handleSubmit: async (values, { props }) => {
    await props.onSubmit(
      dataToSubmit(
        values,
        props.clientId,
        props.data.subscriptionRequest?.subscriptionDetailId || ''
      )
    )
  },
  validate: () => {
    const errors = {}
    return errors
  },
})(ClientSubscriptionChangeStatusFormUI)
